// GLOBAL IMPORTS
import React from 'react';
import { Circle } from 'react-konva';

// APP IMPORTS
import { PointCanvasConfig } from 'utils/annotations/point';

export const Point: React.FC<PointCanvasConfig> = ({ x, y, radius, color, key }) => {
  return <Circle key={key} x={x} y={y} radius={radius} fill={color} stroke="white" strokeWidth={1} />;
};
